import { Box, Button, Grid, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import React from "react";
import { useTranslation } from "react-i18next";
import theme from '../../theme.css';
import { KeyFontIcon } from '../../components/CustomIcons';
import CustomSection from "../../components/CustomSection";
import { TextFieldComponent } from "../../components/CustomFormElement";
import validators from "../../utils/validators";
import { Field, Form } from "react-final-form";

const MIN_LENGTH_PASSWORD = 8;

const useStyles = makeStyles((theme) => ({    
    inform_password: {
        padding: theme.spacing(3),
        backgroundColor: theme.palette.background.default,
        border: '1px solid ' + theme.palette.border.secondary,
        marginTop: theme.spacing(3),
        borderRadius: theme.spacing(3)
    },
}));


export default function ChangePasswordView(props){
    const classes = useStyles();
    const {t} = useTranslation();

    return (
        <CustomSection notMarginTop={true} 
        title={t('btn_change_password')} 
        icon={<KeyFontIcon style={{
            color: theme.palette.common.white,
        }}/>}
        customClass={classes.customClass}
    >
        <Grid item xs={12} marginTop={1} style={{textAlign: 'left'}}>
            <Button variant="contained" color="primary" size='small' onClick={() => props.setShowFormChangePass(!props.showFormChangePass)} className={classes.button}>{t('btn_change_password')}</Button>
        </Grid>
        {props.showFormChangePass && <FormChangePassword 
            t={t}
            classes={classes}
            onChangePassword={props.onChangePassword}
        />}
    </CustomSection>
    );
}


function FormChangePassword(props){
    const {t, classes} = props;

    return (
        <Form
            onSubmit={props.onChangePassword}
            render={({ handleSubmit, reset, submitting, pristine, values }) => (
                <Grid xs={12} container item alignItems="center">
                    <Grid xs={12} item style={{ width: '100%'}}>
                        <Grid xs={12} item >
                            <Field
                                fullWidth
                                name="new_password"
                                component={TextFieldComponent}
                                placeholder={t('new_password') + '*'}
                                type='password'
                                validate={validators.composeValidators(validators.required, validators.validMinLength(MIN_LENGTH_PASSWORD))}
                            />
                        </Grid>
                        <Grid xs={12} item >
                            <Field
                                fullWidth
                                name="confirm_password"
                                component={TextFieldComponent}
                                placeholder={t('confirm_new_password') + '*'}
                                type='password'
                                validate={validators.composeValidators(validators.required, validators.validNotMatch({compareValue: values.new_password, message: t('Enter the same password')},values.confirm_password))}
                            />
                        </Grid>
                        <Grid item xs={12} className={classes.inform_password}>
                            <Typography color='error'>{t('inform_password')}</Typography>
                            <Typography color='error'>{t('inform_password_1')}</Typography>
                            <Typography color='error'>{t('inform_password_2')}</Typography>
                            <Typography color='error'>{t('inform_password_3')}</Typography>
                            <Typography color='error'>{t('inform_password_4')}</Typography>
                            <Typography color='error'>{t('inform_password_5')}</Typography>
                        </Grid>
                        <Grid xs={12} item marginTop={3}>
                            <Box style={{textAlign: 'left'}}>
                                <Button variant="contained" color="primary" size='small' onClick={handleSubmit} className={classes.button}>{t('btn_save')}</Button>
                            </Box>
                        </Grid>
                    </Grid>
                </Grid>
            )}
        />
    );
}